const sharedFormattedResponse = (rawData: any) => {
  const {
    data: {
      data: { link, id },
    },
  } = rawData

  return {
    link,
    id,
  }
}

const passwordFormattedResponse = (rawData: any) => {
  const { data: { data: { password = '' } = {} } = {} } = rawData || {}
  return { password }
}

const linkFormattedResponse = (rawData: any) => {
  const {
    data: {
      data: { link, id, passwordEnabled, accessToken, password },
    },
  } = rawData

  return {
    link,
    id,
    passwordEnabled,
    accessToken,
    password,
  }
}

const sharedApisFormattedResponses = {
  sharedFormattedResponse,
  passwordFormattedResponse,
  linkFormattedResponse,
}

export default sharedApisFormattedResponses
